export const heroData = {
  title: "Gift Tickets",
  subtitle:
    "A special gift from the sky for someone you love. An experience gift delivers emotion that no physical gift ever could.",
  image:
    "https://readdy.ai/api/search-image?query=Luxury%20premium%20gift%20box%20with%20gold%20ribbon%20on%20dark%20navy%20marble%20surface%2C%20warm%20ambient%20soft%20lighting%2C%20elegant%20minimalist%20composition%2C%20champagne%20gold%20tones%2C%20small%20handwritten%20greeting%20card%20beside%20box%2C%20high-end%20editorial%20photography%2C%20no%20text%2C%20ultra%20high%20quality&width=1920&height=700&seq=gifthero02&orientation=landscape",
};

export const valueData = {
  label: "WHY GIFT",
  title: "The Value of an Experience Gift That No Object Can Match",
  description:
    "Things accumulate, but experiences that stay in the heart do not. A helicopter sightseeing gift is a truly special experience that leaves a lifelong impression on both the giver and the recipient.",
  items: [
    {
      icon: "ri-gift-line",
      title: "Emotion That Stays in the Memory",
      desc: "Physical gifts can be set aside, but experiences live in memory — growing more meaningful with time.",
    },
    {
      icon: "ri-heart-3-line",
      title: "A Private Moment for Two",
      desc: "The helicopter cabin is an intimate private space, all to yourselves. Step away from daily life and share breathtaking views and an extraordinary world together.",
    },
    {
      icon: "ri-camera-line",
      title: "Memories Captured in Photos",
      desc: "A commemorative photo against a spectacular aerial backdrop — a treasure to keep forever. The kind of experience that makes everyone ask 'Wow, where was this?'",
    },
    {
      icon: "ri-mail-send-line",
      title: "A Premium Gift, Effortlessly Given",
      desc: "Delivered in an exclusive high-end gift box. The moment of handing it over is itself a special experience.",
    },
  ],
};

export const sceneData = {
  label: "SCENE",
  title: "Popular Gifting Occasions",
  description:
    "Expressing your feelings at a stunning location on a loved one's special day. AIRDOA gift tickets are chosen for a wide range of occasions.",
  scenes: [
    {
      icon: "ri-cake-2-line",
      title: "Birthday",
      desc: "A 'Happy Birthday' delivered alongside breathtaking views from the sky. Make this once-a-year special day even more special.",
    },
    {
      icon: "ri-heart-pulse-line",
      title: "Wedding Anniversary",
      desc: "Add a new layer of wonder to every anniversary. Keep sharing new first-time experiences together as a couple.",
    },
    {
      icon: "ri-hearts-line",
      title: "Proposal & Engagement",
      desc: "A proposal in front of the night view creates a lifelong memory. Also an extremely popular engagement gift.",
    },
    {
      icon: "ri-store-2-line",
      title: "Wedding Gift",
      desc: "A perfect wedding gift for friends or family. Also a wonderful way to celebrate the night before a honeymoon.",
    },
    {
      icon: "ri-medal-line",
      title: "60th & 70th Birthday Celebrations",
      desc: "A once-in-a-lifetime experience for a milestone birthday. Frequently chosen as a surprise gift from family.",
    },
    {
      icon: "ri-briefcase-line",
      title: "Retirement & Promotion",
      desc: "A heartfelt thank-you for years of hard work — an experience gift to mark a fresh new chapter.",
    },
  ],
};

export const giftTypesData = {
  label: "GIFT LINEUP",
  title: "Gift Options",
  subtitle: "Choose the experience that suits the occasion and budget",
  types: [
    {
      id: "short",
      name: "Night View Short",
      tag: "Easy Gift",
      duration: "~15 min",
      route: "Yokohama Harbor Circuit",
      highlights: ["Bay Bridge", "Minato Mirai Night View"],
      includes: [
        "Dedicated gift box",
        "Message card",
        "6-month validity",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Elegant%20luxury%20helicopter%20cabin%20interior%20with%20warm%20ambient%20lighting%2C%20city%20night%20lights%20visible%20through%20large%20window%2C%20romantic%20gift%20experience%20atmosphere%2C%20champagne%20gold%20tones%2C%20editorial%20photography%2C%20no%20text&width=640&height=420&seq=giftplan04&orientation=landscape",
      popular: false,
    },
    {
      id: "standard",
      name: "Night View Standard",
      tag: "Most Popular",
      duration: "~25 min",
      route: "Yokohama & Tokyo Bay Circuit",
      highlights: ["Bay Bridge", "Landmark Tower", "Tokyo Gate Bridge"],
      includes: [
        "Dedicated gift box",
        "Message card",
        "6-month validity",
        "Booking assistance service",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20illuminated%20Yokohama%20Bay%20Bridge%20and%20Minato%20Mirai%20skyline%2C%20deep%20navy%20sky%2C%20thousands%20of%20golden%20city%20lights%20reflecting%20on%20water%2C%20romantic%20gift%20experience%2C%20editorial%20photography%2C%20no%20text&width=640&height=420&seq=giftplan05&orientation=landscape",
      popular: true,
    },
    {
      id: "premium",
      name: "Sunset + Night View Premium",
      tag: "Luxury Gift",
      duration: "~30 min",
      route: "Yokohama & Tokyo Bay + Sunset",
      highlights: [
        "Sunset-to-night transition",
        "Bay Bridge",
        "Tokyo Skytree (distant view)",
      ],
      includes: [
        "Premium gift box",
        "Full message card",
        "6-month validity",
        "Priority booking assistance",
        "Commemorative photo option included",
      ],
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20aerial%20view%20during%20dramatic%20sunset%20transitioning%20to%20night%20over%20coastal%20Japanese%20city%2C%20warm%20orange%20and%20deep%20navy%20gradient%20sky%20with%20city%20lights%20beginning%20to%20sparkle%2C%20luxury%20gift%20experience%2C%20editorial%20photography%2C%20no%20text&width=640&height=420&seq=giftplan06&orientation=landscape",
      popular: false,
    },
  ],
  notes: [
    "Prices vary by plan and season. Please contact us for details.",
    "All plans include dedicated wrapping and a message card.",
    "Booking dates may be changed any number of times within the validity period.",
  ],
};

export const flowData = {
  label: "FLOW",
  title: "From Purchase to Experience",
  steps: [
    {
      num: "01",
      icon: "ri-shopping-cart-line",
      title: "Choose a Plan Online",
      desc: "Select your desired plan on the gift page, enter the recipient's details and your message, and pay by credit card.",
    },
    {
      num: "02",
      icon: "ri-mail-send-line",
      title: "Gift Box Delivered",
      desc: "The ticket and message card are placed in a dedicated gift box and shipped to the specified address, beautifully wrapped.",
    },
    {
      num: "03",
      icon: "ri-calendar-check-line",
      title: "Recipient Makes a Reservation",
      desc: "Using the unique code on the ticket, the recipient can book online or by phone, choosing a date and time that suits them.",
    },
    {
      num: "04",
      icon: "ri-flight-takeoff-line",
      title: "Their Special Experience",
      desc: "On the day, head to the helipad. Breathtaking views from the sky, shared with someone precious — a special moment begins.",
    },
  ],
};

export const deliveryData = {
  label: "DELIVERY",
  title: "Delivery Options",
  methods: [
    {
      title: "Gift Box (Courier)",
      desc: "Delivered in a luxurious dedicated gift box to any address in Japan. The moment of handing it over is itself a special experience.",
      icon: "ri-gift-line",
    },
    {
      title: "Digital Gift (Email)",
      desc: "For urgent gifts or those who live far away, we send a gift code by email. Eco-friendly and available even on the same day.",
      icon: "ri-mail-line",
    },
    {
      title: "In-Person Pickup (By Request)",
      desc: "If you would prefer to pick up in person, please contact us. We can also assist with a hand-delivered presentation.",
      icon: "ri-store-line",
    },
  ],
  packaging: {
    title: "What's Inside the Gift Box",
    items: [
      { label: "Gift Ticket", desc: "Includes a unique code for booking within the validity period" },
      { label: "Message Card", desc: "Printed with a personalized message from the giver" },
      { label: "Experience Guide", desc: "Information on the day-of schedule, attire, and what to bring" },
      { label: "Exclusive Packaging", desc: "Premium gift box with ribbon" },
    ],
    image:
      "https://readdy.ai/api/search-image?query=Flat%20lay%20of%20luxury%20gift%20box%20contents%20on%20dark%20navy%20surface%2C%20elegant%20ticket%20card%2C%20handwritten%20message%20card%2C%20small%20brochure%2C%20champagne%20gold%20ribbon%2C%20warm%20ambient%20lighting%2C%20premium%20unboxing%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=giftbox01&orientation=landscape",
  },
};

export const validityData = {
  label: "VALIDITY",
  title: "About the Validity Period",
  description:
    "Gift tickets are valid for 6 months from the date of purchase. This gives the recipient plenty of time to choose a date at their own convenience.",
  points: [
    {
      icon: "ri-calendar-event-line",
      title: "6-Month Validity",
      desc: "Valid for 6 months from the date of purchase. Booking dates may be changed any number of times within this period.",
    },
    {
      icon: "ri-repeat-line",
      title: "Date Changes",
      desc: "Changes to the booking date due to weather or personal schedule changes are available free of charge within the validity period.",
    },
    {
      icon: "ri-user-add-line",
      title: "Name Change",
      desc: "If the recipient changes, a name change is also available within the validity period.",
    },
  ],
  caution:
    "Tickets cannot generally be used after the expiry date. Please make your reservation promptly as the expiry date approaches.",
};

export const policyData = {
  label: "POLICY",
  title: "Cancellations, Returns & Exchanges",
  description:
    "Our cancellation, return, and exchange policy is clearly defined so you can purchase gift tickets with confidence.",
  policies: [
    {
      type: "cancel",
      title: "Cancellation (After Booking)",
      items: [
        "Up to 3 days before: Booking date change or reschedule available",
        "2 days before to day of: Rescheduling only available if cancelled due to weather",
        "No-show: Ticket forfeited (no refund)",
      ],
    },
    {
      type: "refund",
      title: "Return (Unused Ticket)",
      items: [
        "Within 14 days of purchase: Refund available for unused tickets (minus handling fee)",
        "15+ days after purchase: No returns",
        "After expiry: No returns or refunds",
      ],
    },
    {
      type: "exchange",
      title: "Course Change (Unused)",
      items: [
        "Change to a same or lower price course: Free",
        "Change to a higher price course: Available with payment of the difference",
        "Any number of changes available within the validity period",
      ],
    },
  ],
};

export const faqData = {
  label: "FAQ",
  title: "Frequently Asked Questions",
  questions: [
    {
      q: "Can I purchase a gift ticket on the same day?",
      a: "Yes, digital gifts (email) can be purchased on the same day. For gift box (courier) orders, delivery takes 2–3 days, so we recommend purchasing in advance.",
    },
    {
      q: "How many characters can the message card hold?",
      a: "Up to 200 characters. You can freely mix kanji, hiragana, katakana, and alphabet characters.",
    },
    {
      q: "Will the recipient be charged any additional fees?",
      a: "No additional fees are charged for the course listed on the ticket. Additional fees only apply if optional add-ons (e.g., commemorative photos) are requested.",
    },
    {
      q: "Can the validity period be extended?",
      a: "As a general rule, extensions are not available. However, if you have special circumstances, please contact us — we will discuss on a case-by-case basis.",
    },
    {
      q: "Can multiple tickets be purchased and wrapped together?",
      a: "Yes, for multiple ticket purchases, they can be placed in a single gift box or wrapped individually. Please specify your preference in the notes at checkout.",
    },
    {
      q: "Can a digital gift be printed and handed over in person?",
      a: "Yes, digital gifts can be printed and handed over. Print the attached PDF on good-quality paper and hand it over with a message card for an easy yet special presentation.",
    },
  ],
};

export const finalCTA = {
  title: "Give the gift of the sky\nto someone special",
  subtitle:
    "Would you like to give a truly special memory on a special day? Please contact us via our dedicated gift line or online form.",
  ctas: [
    {
      label: "Inquire About Gift Purchase",
      href: "/contact",
      type: "primary" as const,
    },
    {
      label: "View Courses & Pricing",
      href: "/pricing",
      type: "secondary" as const,
    },
  ],
  contact: {
    label: "Gift Dedicated Line",
    tel: "0120-XXX-XXX",
    hours: "10:00–18:00 (including weekends and holidays)",
  },
};
